import React from "react"

export const Css = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 49 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 0H48.875L44.4979 49.4152L24.7598 55L5.13167 49.4129L0.75 0ZM39.9146 10.1131L9.71042 10.1063L10.1985 16.115L33.4017 16.1196L32.8173 22.3438H17.6006L18.1506 28.2402H32.3177L31.479 36.3138L24.8102 38.1563L18.036 36.3L17.6052 31.4646H11.624L12.2885 40.299L24.8125 44.2017L37.1256 40.6954L39.9146 10.1154V10.1131Z"
        fill="#299EFA"
      />
    </svg>
  )
}

export const Figma = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M10 60C15.52 60 20 55.52 20 50V40H10C4.48 40 0 44.48 0 50C0 55.52 4.48 60 10 60Z"
        fill="#0ACF83"
      />
      <path
        d="M0 30C0 24.48 4.48 20 10 20H20V40H10C4.48 40 0 35.52 0 30Z"
        fill="#A259FF"
      />
      <path
        d="M0 10C0 4.48 4.48 0 10 0H20V20H10C4.48 20 0 15.52 0 10Z"
        fill="#F24E1E"
      />
      <path
        d="M20 0H30C35.52 0 40 4.48 40 10C40 15.52 35.52 20 30 20H20V0Z"
        fill="#FF7262"
      />
      <path
        d="M40 30C40 35.52 35.52 40 30 40C24.48 40 20 35.52 20 30C20 24.48 24.48 20 30 20C35.52 20 40 24.48 40 30Z"
        fill="#1ABCFE"
      />
    </svg>
  )
}

export const Gatsby = () => {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <g>
        <path
          d="M12.001.007C5.326.007.007 5.326.007 12S5.326 23.995 12 23.995s11.994-5.319 11.994-11.994S18.676.007 12.001.007zM2.614 12.105l9.283 9.283c-5.111 0-9.283-4.172-9.283-9.283zm11.473 9.074L2.823 9.915C3.76 5.743 7.516 2.614 12 2.614a9.476 9.476 0 0 1 7.614 3.86L18.259 7.62a7.657 7.657 0 0 0-6.362-3.337A7.555 7.555 0 0 0 4.7 9.393l9.804 9.805c2.4-.835 4.276-2.92 4.798-5.424h-4.068v-1.773h6.154c0 4.485-3.129 8.24-7.301 9.178z"
          fill="purple"
        />
      </g>
    </svg>
  )
}

export const Git = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M58.8684 27.3267L32.6719 1.1315C31.1641 -0.377168 28.7173 -0.377168 27.2077 1.1315L21.7678 6.57135L28.6685 13.4721C30.2721 12.9302 32.111 13.2937 33.3893 14.572C34.6737 15.8585 35.0346 17.7131 34.4796 19.3218L41.13 25.9724C42.739 25.4181 44.5955 25.7767 45.8805 27.0639C47.6766 28.8592 47.6766 31.769 45.8805 33.5655C44.0841 35.3622 41.1743 35.3622 39.3769 33.5655C38.0259 32.2131 37.6922 30.2292 38.3761 28.5649L32.1741 22.3628L32.1734 38.684C32.623 38.9063 33.0336 39.1999 33.3893 39.5535C35.1853 41.3488 35.1853 44.2588 33.3893 46.0567C31.5928 47.8525 28.6816 47.8525 26.8877 46.0567C25.0917 44.2588 25.0917 41.3491 26.8877 39.5538C27.3181 39.1232 27.8296 38.7821 28.3927 38.5504V22.0771C27.8288 21.847 27.317 21.5057 26.8877 21.0738C25.527 19.7149 25.1998 17.7182 25.897 16.0474L19.0945 9.24416L1.13203 27.2055C-0.377344 28.7156 -0.377344 31.1627 1.13203 32.6716L27.3291 58.8672C28.8373 60.3761 31.2837 60.3761 32.7937 58.8672L58.8682 32.7932C60.3771 31.2838 60.3771 28.8353 58.8682 27.3267"
        fill="#DE4C36"
      />
    </svg>
  )
}

export const Html = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 49 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H48.125L43.7479 49.4152L24.0098 55L4.38396 49.4129L0 0ZM16.1127 22.3438L15.581 16.115L38.6329 16.1219L39.16 10.1131L8.965 10.1063L10.5646 28.4625H31.4783L30.7313 36.3138L24.0625 38.1563L17.2906 36.3L16.8598 31.4646H10.8808L11.6371 41.0231L24.0625 44.346L36.3894 41.0392L38.0944 22.346H16.1127V22.3438Z"
        fill="#F06235"
      />
    </svg>
  )
}

export const Js = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path d="M0 0H60V60H0V0Z" fill="#F7DF1E" />
      <path
        d="M15.7763 50.1404L20.3677 47.3616C21.2536 48.9321 22.0594 50.2611 23.9923 50.2611C25.845 50.2611 27.0134 49.5364 27.0134 46.7173V27.5459H32.6517V46.797C32.6517 52.6369 29.2284 55.2952 24.2339 55.2952C19.7234 55.2952 17.1052 52.9592 15.776 50.1399"
        fill="black"
      />
      <path
        d="M35.7143 49.5361L40.3052 46.8781C41.5139 48.8517 43.0847 50.3016 45.8634 50.3016C48.1999 50.3016 49.6896 49.1335 49.6896 47.5224C49.6896 45.5892 48.1591 44.9044 45.5815 43.7771L44.1722 43.1724C40.1041 41.441 37.4058 39.266 37.4058 34.6746C37.4058 30.4456 40.6277 27.2234 45.6623 27.2234C49.2469 27.2234 51.8245 28.4721 53.677 31.7344L49.2867 34.5539C48.3199 32.8221 47.2732 32.1375 45.6621 32.1375C44.0107 32.1375 42.9635 33.1847 42.9635 34.5539C42.9635 36.2454 44.0107 36.9305 46.4271 37.9777L47.8366 38.5817C52.6296 40.636 55.328 42.7301 55.328 47.442C55.328 52.5171 51.3408 55.2959 45.9841 55.2959C40.7484 55.2959 37.3652 52.7989 35.7141 49.5364"
        fill="black"
      />
    </svg>
  )
}

export const Ts = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path d="M0 30V60H60V0H0V30Z" fill="#007ACC" />
      <path
        d="M13.2682 30.1992L13.2492 32.6561H21.0586V54.8468H26.5828V32.6561H34.3922V30.2468C34.3922 28.9132 34.3636 27.799 34.3256 27.7704C34.297 27.7324 29.5446 27.7132 23.7827 27.7228L13.297 27.7514L13.2684 30.199L13.2682 30.1992Z"
        fill="white"
      />
      <path
        d="M48.4141 27.6816C49.9378 28.0627 51.0998 28.7386 52.1665 29.8435C52.7189 30.4341 53.5378 31.5104 53.6046 31.7675C53.6234 31.8436 51.0141 33.5961 49.4332 34.5769C49.376 34.6151 49.1473 34.3674 48.8902 33.9863C48.1188 32.8627 47.3093 32.3768 46.0711 32.2913C44.2523 32.1673 43.0807 33.1198 43.0903 34.71C43.0903 35.1769 43.1569 35.453 43.3474 35.8341C43.7475 36.6626 44.4902 37.1579 46.8237 38.1673C51.1188 40.0151 52.9568 41.2341 54.0998 42.9673C55.376 44.9009 55.6617 47.9865 54.795 50.2817C53.8427 52.7768 51.4809 54.4723 48.1568 55.0341C47.1284 55.215 44.6904 55.1865 43.5855 54.9865C41.1762 54.5579 38.8903 53.3675 37.4808 51.8056C36.9284 51.196 35.8521 49.6055 35.9189 49.4911C35.9475 49.4532 36.195 49.3008 36.4711 49.1389C36.7378 48.9865 37.7475 48.4053 38.6998 47.8531L40.4236 46.853L40.7855 47.3865C41.2903 48.1578 42.3949 49.215 43.0617 49.5673C44.9759 50.577 47.6046 50.434 48.8998 49.272C49.4522 48.7674 49.6807 48.2436 49.6807 47.472C49.6807 46.7768 49.5949 46.4722 49.233 45.9486C48.7666 45.2818 47.8141 44.7197 45.1092 43.5486C42.0141 42.215 40.6807 41.3865 39.4617 40.0721C38.757 39.3104 38.0902 38.0911 37.8141 37.0721C37.5855 36.2246 37.5281 34.1007 37.7093 33.2436C38.3475 30.2529 40.6045 28.1675 43.8616 27.5483C44.9187 27.3483 47.3759 27.4245 48.4141 27.6818V27.6816Z"
        fill="white"
      />
    </svg>
  )
}

export const ReactIco = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.3308 17.8086C48.6923 17.5831 48.0483 17.3742 47.3996 17.1821C47.5086 16.7238 47.6089 16.271 47.6979 15.8262C49.1599 8.52152 48.2042 2.63676 44.9397 0.69922C41.8096 -1.15824 36.6908 0.778584 31.5211 5.40944C31.0116 5.86665 30.5134 6.33703 30.027 6.82014C29.7013 6.49889 29.37 6.18387 29.033 5.87525C23.6148 0.923804 18.184 -1.16306 14.923 0.780031C11.7958 2.64328 10.8698 8.17536 12.186 15.0981C12.317 15.7838 12.4648 16.4658 12.6295 17.1437C11.8607 17.3686 11.119 17.6079 10.4091 17.8626C4.0567 20.1422 0 23.7146 0 27.4201C0 31.2471 4.35505 35.0858 10.9713 37.4134C11.5077 37.6013 12.0486 37.7755 12.5934 37.9357C12.4164 38.6658 12.2593 39.4009 12.1223 40.14C10.8675 46.9426 11.8474 52.344 14.9661 54.1954C18.1873 56.1074 23.5937 54.1423 28.8579 49.4058C29.2848 49.0208 29.7022 48.6248 30.1099 48.2183C30.6367 48.7414 31.1775 49.2493 31.7318 49.7414C36.8312 54.2576 41.8673 56.0813 44.983 54.2248C48.2011 52.3073 49.2471 46.5048 47.8892 39.4453C47.7822 38.8922 47.6623 38.3419 47.5294 37.7948C47.9091 37.679 48.2818 37.5598 48.645 37.4358C55.5233 35.0904 59.9986 31.2983 59.9986 27.4201C59.9986 23.701 55.8109 20.1046 49.3308 17.8086V17.8086ZM47.839 34.9319C47.5109 35.0436 47.1744 35.1514 46.8312 35.2564C46.0719 32.7821 45.0472 30.1512 43.7931 27.4328C44.9898 24.7793 45.9751 22.182 46.7131 19.7239C47.3269 19.9068 47.9225 20.0995 48.4967 20.3029C54.0489 22.2703 57.4355 25.1788 57.4355 27.4201C57.4355 29.8072 53.778 32.9063 47.839 34.9319V34.9319ZM45.3749 39.9576C45.9753 43.0791 46.0609 45.9015 45.6632 48.108C45.306 50.0907 44.5874 51.4124 43.6987 51.9419C41.808 53.0684 37.7644 51.6041 33.4035 47.7416C32.888 47.2841 32.3849 46.8119 31.8949 46.3256C33.5856 44.4225 35.2752 42.2102 36.9242 39.7531C39.8248 39.4882 42.565 39.055 45.05 38.4637C45.1724 38.972 45.2811 39.4704 45.3749 39.9576V39.9576ZM20.4548 51.7472C18.6075 52.4185 17.1362 52.4378 16.2467 51.91C14.3542 50.7866 13.5674 46.4496 14.6406 40.6321C14.7682 39.9447 14.9142 39.261 15.0786 38.5819C17.5362 39.1416 20.2566 39.5439 23.1639 39.7866C24.8242 42.1909 26.5625 44.4008 28.3144 46.336C27.9421 46.7068 27.561 47.0681 27.1714 47.4196C24.8434 49.5139 22.5107 50.9999 20.4548 51.7472V51.7472ZM11.8005 34.9172C8.87487 33.8879 6.45876 32.5503 4.8027 31.0906C3.31445 29.779 2.5633 28.4766 2.5633 27.4201C2.5633 25.1713 5.82033 22.3031 11.2528 20.3538C11.9121 20.1174 12.602 19.8942 13.318 19.6848C14.069 22.1984 15.0538 24.8266 16.2423 27.4842C15.0383 30.1812 14.0394 32.8513 13.2813 35.3946C12.7839 35.248 12.2902 35.0888 11.8005 34.9172V34.9172ZM14.7015 14.5913C13.574 8.66023 14.3228 4.18617 16.2074 3.06326C18.2145 1.86725 22.653 3.57249 27.3312 7.84801C27.6363 8.12745 27.9364 8.41255 28.2314 8.70317C26.4882 10.6299 24.7658 12.8233 23.1203 15.2134C20.2985 15.4826 17.5974 15.9149 15.114 16.4941C14.961 15.8636 14.8235 15.2292 14.7015 14.5915V14.5913ZM40.5823 21.1691C39.9957 20.1263 39.3874 19.0965 38.7577 18.0807C40.672 18.3299 42.5062 18.6606 44.2286 19.0649C43.7116 20.7708 43.067 22.5542 42.3084 24.3828C41.7539 23.2998 41.1784 22.2284 40.5823 21.1691V21.1691ZM30.0281 10.5886C31.2103 11.9069 32.3943 13.3787 33.5589 14.9756C31.1965 14.8607 28.8301 14.8603 26.4676 14.9741C27.6333 13.3919 28.8275 11.9221 30.0281 10.5886ZM19.4063 21.1872C18.8176 22.238 18.2529 23.3027 17.7125 24.3806C16.9662 22.5586 16.3276 20.767 15.8061 19.0369C17.5179 18.6427 19.3435 18.3204 21.2456 18.0758C20.6089 19.0979 19.9956 20.1352 19.4063 21.187V21.1872ZM21.3002 36.9519C19.335 36.7262 17.4821 36.4205 15.7707 36.037C16.3004 34.276 16.9531 32.4463 17.7155 30.5852C18.258 31.6639 18.8251 32.7293 19.4163 33.7805C20.0243 34.8612 20.6538 35.9197 21.3002 36.9519ZM30.0989 44.4373C28.8839 43.0883 27.6722 41.5958 26.4889 39.9907C27.6378 40.037 28.8089 40.0607 29.9993 40.0607C31.2222 40.0607 32.4311 40.0324 33.621 39.9779C32.4527 41.612 31.2731 43.1066 30.0989 44.4373ZM42.3325 30.4902C43.1345 32.3717 43.8105 34.1918 44.3472 35.9226C42.6077 36.3313 40.7294 36.6603 38.7504 36.9047C39.3846 35.8699 39.9987 34.8223 40.5923 33.7624C41.1959 32.6851 41.7761 31.5941 42.3325 30.4902V30.4902ZM38.3722 32.4444C37.4633 34.0694 36.5034 35.6635 35.4939 37.2243C33.6652 37.3576 31.8325 37.4238 29.9993 37.4228C28.1321 37.4228 26.3159 37.363 24.5671 37.2462C23.5312 35.6891 22.553 34.0921 21.6344 32.4588H21.6346C20.7204 30.8342 19.8665 29.1744 19.0746 27.483C19.8644 25.7913 20.7158 24.1307 21.6269 22.5048L21.6267 22.505C22.5374 20.8787 23.5079 19.2886 24.5359 17.7381C26.3202 17.5992 28.1499 17.5268 29.9991 17.5268H29.9993C31.8569 17.5268 33.689 17.5999 35.4728 17.7398C36.4904 19.288 37.4547 20.8726 38.3637 22.4908C39.2778 24.1131 40.1405 25.7656 40.9502 27.4456C40.1488 29.1428 39.2889 30.8101 38.3722 32.4444V32.4444ZM43.6595 2.98461C45.6685 4.17725 46.4499 8.98661 45.1876 15.2935C45.107 15.6959 45.0165 16.1057 44.9181 16.5214C42.4286 15.9299 39.7256 15.4901 36.8956 15.2168C35.2471 12.8004 33.5387 10.6036 31.8239 8.70172C32.2733 8.25581 32.7334 7.82147 33.2038 7.39909C37.6334 3.43161 41.7733 1.86508 43.6595 2.98461V2.98461ZM29.9993 21.9056C32.9582 21.9056 35.357 24.3746 35.357 27.4201C35.357 30.4656 32.9582 32.9345 29.9993 32.9345C27.0404 32.9345 24.6416 30.4656 24.6416 27.4201C24.6416 24.3746 27.0404 21.9056 29.9993 21.9056V21.9056Z"
        fill="#00D8FF"
      />
    </svg>
  )
}

export const VsCode = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0">
        <path
          d="M42.7192 59.6711C43.1985 59.858 43.7111 59.9443 44.2252 59.9246C44.7393 59.9048 45.2438 59.7795 45.7073 59.5563L58.1092 53.5889C58.7479 53.2814 59.2868 52.7998 59.664 52.1996C60.0411 51.5993 60.2411 50.9048 60.241 50.1959V9.73224C60.2411 9.02337 60.0411 8.32888 59.6639 7.72867C59.2868 7.12845 58.7479 6.6469 58.1092 6.33941L45.7076 0.371768C45.0068 0.0345642 44.2186 -0.0764627 43.4519 0.0540552C42.6853 0.184573 41.9782 0.550181 41.4284 1.10027L17.6866 22.7605L7.3449 14.9104C6.87841 14.5563 6.30267 14.3767 5.71758 14.4027C5.13249 14.4287 4.57497 14.6588 4.14175 15.0529L0.82498 18.0701C-0.268721 19.0648 -0.269902 20.7855 0.822145 21.7818L9.79073 29.9641L0.822145 38.146C-0.269902 39.1426 -0.268721 40.863 0.82498 41.858L4.14175 44.875C4.57494 45.2692 5.13245 45.4992 5.71754 45.5253C6.30263 45.5513 6.87838 45.3718 7.3449 45.0177L17.6866 37.1674L41.4284 58.8276C41.7955 59.1953 42.2351 59.4825 42.7192 59.6711V59.6711ZM45.191 16.2895L27.1763 29.9641L45.191 43.6384V16.2895V16.2895Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M58.1459 6.34796L45.7344 0.37205C45.0334 0.0345742 44.2449 -0.0766892 43.478 0.053657C42.711 0.184003 42.0035 0.549514 41.4534 1.09961L0.822512 38.1454C-0.270244 39.142 -0.268827 40.8624 0.825346 41.8573L4.14424 44.8743C4.57782 45.2686 5.13568 45.4987 5.72111 45.5247C6.30654 45.5508 6.88263 45.3712 7.34952 45.017L56.2783 7.89827C57.9198 6.65315 60.2776 7.82386 60.2776 9.88418V9.74008C60.2775 9.03135 60.0775 8.33702 59.7004 7.73694C59.3233 7.13686 58.7845 6.65541 58.1459 6.34796V6.34796Z"
          fill="#0065A9"
        />
        <path
          d="M58.1459 53.5785L45.7344 59.5544C45.0334 59.8918 44.2449 60.0031 43.478 59.8727C42.711 59.7424 42.0035 59.3769 41.4534 58.8269L0.822512 21.7811C-0.270244 20.7848 -0.268827 19.0641 0.825346 18.0694L4.14424 15.0522C4.57785 14.658 5.13572 14.4279 5.72115 14.4019C6.30658 14.3759 6.88266 14.5555 7.34952 14.9097L56.2783 52.0282C57.9198 53.2733 60.2776 52.1026 60.2776 50.0421V50.1864C60.2775 50.8951 60.0774 51.5895 59.7004 52.1895C59.3233 52.7896 58.7845 53.2711 58.1459 53.5785V53.5785Z"
          fill="#007ACC"
        />
        <path
          d="M45.6954 59.5592C44.9943 59.8964 44.2057 60.0075 43.4387 59.877C42.6717 59.7466 41.9641 59.381 41.4139 58.8309C42.8032 60.2199 45.1788 59.236 45.1788 57.2711V2.66288C45.1788 0.697997 42.8032 -0.285861 41.4139 1.10335C41.9641 0.553212 42.6716 0.187609 43.4386 0.0570997C44.2057 -0.0734092 44.9943 0.0376251 45.6954 0.374848L58.1048 6.34249C58.7438 6.64977 59.283 7.13124 59.6603 7.73147C60.0377 8.33171 60.2379 9.02631 60.2379 9.73532V50.1992C60.2379 51.646 59.4087 52.9651 58.1048 53.592L45.6954 59.5594V59.5592Z"
          fill="#1F9CF0"
        />
        <path
          d="M42.7191 59.6704C43.1984 59.8573 43.711 59.9436 44.2251 59.9238C44.7392 59.9041 45.2437 59.7787 45.7073 59.5556L58.1088 53.588C58.7476 53.2806 59.2866 52.799 59.6638 52.1988C60.041 51.5986 60.241 50.9041 60.241 50.1952V9.73155C60.241 9.02268 60.041 8.32819 59.6638 7.72797C59.2867 7.12776 58.7478 6.6462 58.1091 6.33871L45.707 0.370837C45.0063 0.0336872 44.2181 -0.0773103 43.4515 0.0532065C42.6849 0.183723 41.9778 0.5493 41.4281 1.09934L17.6865 22.7598L7.34481 14.9097C6.87832 14.5556 6.30258 14.376 5.71749 14.402C5.1324 14.428 4.57488 14.6581 4.14166 15.0522L0.824888 18.0694C-0.268813 19.0641 -0.269994 20.7848 0.822054 21.7812L9.79064 29.9634L0.822054 38.1453C-0.269994 39.1419 -0.268813 40.8623 0.824888 41.8573L4.14166 44.8743C4.57485 45.2685 5.13236 45.4985 5.71745 45.5246C6.30254 45.5506 6.87829 45.3711 7.34481 45.017L17.6865 37.1667L41.4281 58.8269C41.7953 59.1946 42.2349 59.4818 42.7191 59.6704V59.6704ZM45.1909 16.2886L27.1762 29.9634L45.1909 43.6377V16.2888V16.2886Z"
          fill="url(#paint0_linear)"
          fill-opacity="0.25"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="30.1224"
          y1="0"
          x2="30.1224"
          y2="59.9266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const StyledComponents = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45 60V53.3334C45 53.3334 45 46.6667 51.6667 46.6667C58.3333 46.6667 58.3333 53.3334 58.3333 53.3334V60H45ZM30 60V45C30 45 30 38.3334 36.6667 38.3334C43.3333 38.3334 43.3333 45 43.3333 45V60H30ZM15 60V40C15 40 15 33.3334 21.6667 33.3334C28.3333 33.3334 28.3333 40 28.3333 40V60H15ZM0 60V45C0 45 0 38.3334 6.66667 38.3334C13.3333 38.3334 13.3333 45 13.3333 45V60H0Z"
        fill="#FFDC5D"
      />
      <path
        d="M26.6667 40C26.6667 37.2383 26.6667 26.6666 21.6667 26.6666C16.6667 26.6666 16.6667 37.2383 16.6667 40C16.6667 42.7616 18.905 45 21.6667 45C24.4283 45 26.6667 42.7616 26.6667 40ZM11.6667 45C11.6667 42.2383 11.6667 31.6666 6.66666 31.6666C1.66666 31.6666 1.66666 42.2383 1.66666 45C1.66666 47.7616 3.90499 50 6.66666 50C9.42832 50 11.6667 47.7616 11.6667 45ZM41.6667 45C41.6667 42.2383 41.6667 31.6666 36.6667 31.6666C31.6667 31.6666 31.6667 42.2383 31.6667 45C31.6667 47.7616 33.9067 50 36.6667 50C39.4283 50 41.6667 47.7616 41.6667 45ZM56.6667 53.3333C56.6667 50.5716 56.6667 40 51.6667 40C46.6667 40 46.6667 50.5716 46.6667 53.3333C46.6667 56.095 48.9067 58.3333 51.6667 58.3333C54.4283 58.3333 56.6667 56.095 56.6667 53.3333Z"
        fill="#DD2E44"
      />
      <path
        d="M21.6667 26.6667V33.3334H25C25 33.3334 28.3333 33.3334 35 26.6667L31.6667 23.3334C31.6667 23.3334 28.3333 26.6667 21.6667 26.6667Z"
        fill="#DD2E44"
      />
      <path
        d="M31.6667 23.3333L45 10L48.3333 13.3333L35 26.6667L31.6667 23.3333Z"
        fill="#8899A6"
      />
      <path
        d="M45 10C45 10 41.6667 6.66667 45 3.33333L48.3333 0H60V8.33333L55 13.3333C51.6667 16.6667 48.3333 13.3333 48.3333 13.3333L45 10Z"
        fill="#8899A6"
      />
    </svg>
  )
}

export const Twitter = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 74 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M73.8655 7.10718C71.8086 10.1667 69.2851 12.7747 66.2951 14.9314C66.3246 15.5098 66.3394 16.1635 66.3394 16.8926C66.3394 20.9435 65.7488 24.9993 64.5676 29.06C63.3864 33.1208 61.5821 37.0077 59.1547 40.7206C56.7273 44.4336 53.8358 47.7229 50.4802 50.5887C47.1247 53.4545 43.0911 55.7395 38.3796 57.4437C33.6681 59.1479 28.6186 60.0001 23.2312 60.0001C14.8232 60.0001 7.08023 57.7302 0.00234985 53.1905C1.25859 53.3303 2.46343 53.4002 3.61687 53.4002C10.6411 53.4002 16.9148 51.2366 22.4381 46.9096C19.163 46.8495 16.2299 45.8413 13.6388 43.885C11.0478 41.9287 9.26465 39.429 8.28949 36.3857C9.25337 36.5693 10.2047 36.6611 11.1434 36.6611C12.4947 36.6611 13.8244 36.4849 15.1324 36.1324C11.6372 35.4324 8.73775 33.6916 6.43387 30.91C4.13007 28.1285 2.97817 24.918 2.97817 21.2786V21.0911C5.12349 22.2789 7.41181 22.9108 9.84313 22.9866C7.77265 21.6063 6.13107 19.8063 4.91839 17.5867C3.70563 15.367 3.09925 12.965 3.09925 10.3805C3.09925 7.65482 3.78227 5.11666 5.14831 2.76606C8.94919 7.43034 13.5547 11.1582 18.965 13.9496C24.3753 16.741 30.1795 18.2913 36.3777 18.6004C36.1133 17.4987 35.9809 16.349 35.9804 15.1513C35.9804 10.9695 37.4603 7.3988 40.4201 4.43928C43.3799 1.47976 46.9507 0 51.1325 0C55.5108 0 59.1986 1.59422 62.1961 4.78266C65.6208 4.1043 68.8274 2.87732 71.816 1.10172C70.6646 4.72532 68.446 7.52068 65.1601 9.4878C68.1801 9.12892 71.0819 8.33538 73.8653 7.10718H73.8655Z"
          fill="#gradient"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="73.866" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Github = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 62 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient id="gradient" x2="1" y2="1">
        <stop offset="0%" stop-color="#72CFFD" />
        <stop offset="60%" stop-color="#FBDE3F" />
        <stop offset="100%" stop-color="#FF25A8" />
      </linearGradient>
      <path
        d="M30.9677 0C13.5484 0 0 13.5484 0 30.9677C0 51.2903 18.3871 60 21.2903 60C23.2258 60 23.2258 59.0323 23.2258 58.0645V53.2258C16.4516 55.1613 13.5484 51.2903 12.5806 48.3871C12.5806 48.3871 12.5806 47.4194 10.6452 45.4839C9.67742 44.5161 5.80645 42.5806 9.67742 42.5806C12.5806 42.5806 14.5161 46.4516 14.5161 46.4516C17.4194 50.3226 21.2903 49.3548 23.2258 48.3871C23.2258 46.4516 25.1613 44.5161 25.1613 44.5161C17.4194 43.5484 11.6129 40.6452 11.6129 30C11.6129 26.129 12.5806 23.2258 14.5161 21.2903C14.5161 21.2903 12.5806 17.4194 14.5161 12.5806C14.5161 12.5806 19.3548 12.5806 23.2258 16.4516C26.129 14.5161 35.8065 14.5161 38.7097 16.4516C42.5806 12.5806 47.4194 12.5806 47.4194 12.5806C49.3548 19.3548 47.4194 21.2903 47.4194 21.2903C49.3548 23.2258 50.3226 26.129 50.3226 30C50.3226 40.6452 43.5484 43.5484 36.7742 44.5161C37.7419 45.4839 38.7097 47.4194 38.7097 50.3226V58.0645C38.7097 59.0323 38.7097 60 40.6452 60C43.5484 60 61.9355 51.2903 61.9355 30.9677C61.9355 13.5484 48.3871 0 30.9677 0Z"
        fill="#gradient"
      />
    </svg>
  )
}

export const Linkedin = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.1125 51.1315H42.2381V37.2063C42.2381 33.8858 42.1688 29.6185 37.5975 29.6185C32.97 29.6185 32.265 33.2202 32.265 36.9607V51.1297H23.3794V22.4974H31.9144V26.4029H32.0288C33.2213 24.1474 36.1219 21.7756 40.4494 21.7756C49.4513 21.7756 51.1219 27.7023 51.1219 35.4083V51.1297L51.1125 51.1315ZM13.3406 18.5844C12.6624 18.5847 11.9908 18.4511 11.3642 18.1914C10.7377 17.9317 10.1686 17.5509 9.68941 17.0709C9.21026 16.5909 8.83052 16.0211 8.57194 15.3941C8.31336 14.7671 8.18102 14.0953 8.1825 13.4171C8.18361 12.3963 8.48739 11.3987 9.05543 10.5505C9.62346 9.70235 10.4302 9.04164 11.3738 8.65193C12.3173 8.26223 13.3552 8.16103 14.3562 8.36114C15.3573 8.56124 16.2765 9.05366 16.9977 9.77614C17.7189 10.4986 18.2096 11.4187 18.4079 12.4201C18.6062 13.4214 18.5031 14.4591 18.1117 15.4019C17.7203 16.3447 17.0581 17.1502 16.2088 17.7167C15.3596 18.2832 14.3615 18.5852 13.3406 18.5844V18.5844ZM17.7919 51.1315H8.8875V22.4993H17.7919V51.1315ZM55.5675 0H4.425C1.98187 0 0 1.93306 0 4.32549V55.6745C0 58.0669 1.98187 60 4.425 60H55.5581C57.9975 60 60 58.0669 60 55.6745V4.32549C60 1.93306 57.9975 0 55.5581 0H55.5675Z"
        fill="#gradient"
      />
    </svg>
  )
}

export const Mail = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 44 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.00824738 5.181L22 16.1755L43.9917 5.181C43.9103 3.77972 43.2962 2.46259 42.2753 1.49937C41.2543 0.536155 39.9036 -0.000257358 38.5 9.26293e-08H5.5C4.09635 -0.000257358 2.74573 0.536155 1.72474 1.49937C0.703745 2.46259 0.0896586 3.77972 0.00824738 5.181V5.181Z"
        fill="#gradient"
      />
      <path
        d="M44 11.3245L22 22.3245L0 11.3245V27.5C0 28.9587 0.579462 30.3576 1.61091 31.3891C2.64236 32.4205 4.04131 33 5.5 33H38.5C39.9587 33 41.3576 32.4205 42.3891 31.3891C43.4205 30.3576 44 28.9587 44 27.5V11.3245Z"
        fill="#gradient"
      />
    </svg>
  )
}

export const Menu = () => {
  return (
    <svg
      role="img"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333336 0.333344H8.66667V8.66668H0.333336V0.333344Z"
        fill="black"
      />
      <path
        d="M0.333336 12.8333H8.66667V21.1667H0.333336V12.8333Z"
        fill="black"
      />
      <path
        d="M8.66667 25.3333H0.333336V33.6667H8.66667V25.3333Z"
        fill="black"
      />
      <path
        d="M12.8333 0.333344H21.1667V8.66668H12.8333V0.333344Z"
        fill="black"
      />
      <path
        d="M21.1667 12.8333H12.8333V21.1667H21.1667V12.8333Z"
        fill="black"
      />
      <path
        d="M12.8333 25.3333H21.1667V33.6667H12.8333V25.3333Z"
        fill="black"
      />
      <path
        d="M33.6667 0.333344H25.3333V8.66668H33.6667V0.333344Z"
        fill="black"
      />
      <path
        d="M25.3333 12.8333H33.6667V21.1667H25.3333V12.8333Z"
        fill="black"
      />
      <path
        d="M33.6667 25.3333H25.3333V33.6667H33.6667V25.3333Z"
        fill="black"
      />
    </svg>
  )
}

export const Close = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 3.48854L26.5115 0L15 11.5115L3.48854 0L0 3.48854L11.5115 15L0 26.5115L3.48854 30L15 18.4885L26.5115 30L30 26.5115L18.4885 15L30 3.48854Z"
        fill="white"
      />
    </svg>
  )
}
